<template>
  <section class="f-37">
    <div class="alive_content">
      <div class="title f-center-title">布局精简，应用氛围更沉浸</div>
      <div class="content" v-ia>
        <div class="border_container_light video_size f-select-center">
          <m-video
            ref="video2"
            playsinline
            webkit-playsinline
            disablepictureinpicture
            src="@/v2/auto/assets/video/37/2.mp4"
            muted
          />
        </div>
        <replay class="replay" @click="() => replayVideo(this.$refs.video2)" />
      </div>
    </div>
    <div class="alive_content">
      <div class="title f-center-title">空间感更强，画面更沉浸</div>
      <div class="content" v-ia>
        <div class="border_container_light video_size f-select-center">
          <slider
            v-model:value="activeIndex"
            :controlBtn="false"
            :indicators="false"
            :autoplay="false"
            :touch="false"
            stopOnHover
            height="100%"
            width="100%"
          >
            <slider-item v-for="(i, index) in controlList" :key="i.title">
              <div>
                <m-video
                  :ref="`sliderVideo${index}`"
                  disablepictureinpicture
                  playsinline
                  webkit-playsinline
                  :src="i.url"
                  preload="auto"
                  :poster="i.poster"
                  muted
                />
              </div>
            </slider-item>
          </slider>
        </div>
        <div class="des">
          <div class="des_text f-center-sub-title">
            {{ controlList[activeIndex].des }}
          </div>
          <replay
            class="replay"
            @click="
              () => replayVideo(this.$refs[`sliderVideo${this.activeIndex}`][0])
            "
          />
        </div>
        <div class="control_container">
          <div class="alive_control">
            <div
              v-for="(i, index) in controlList"
              class="control_item"
              :class="index === activeIndex && 'control_item_active'"
              @click="controlClick(index)"
            >
              {{ i.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import poster0 from '@/v2/auto/assets/video/37/3_0_poster.webp'
import poster1 from '@/v2/auto/assets/video/37/3_1_poster.webp'
import poster2 from '@/v2/auto/assets/video/37/3_2_poster.webp'
import mp4_0 from '@/v2/auto/assets/video/37/3_0.mp4'
import mp4_1 from '@/v2/auto/assets/video/37/3_1.mp4'
import mp4_2 from '@/v2/auto/assets/video/37/3_2.mp4'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      videoAbortController: new AbortController(),
      controlList: [
        {
          title: '取色播放器',
          des: '经典黑胶唱片，背景颜色随歌曲封面变化，画面更沉浸、通透',
          poster: poster0,
          url: mp4_0,
        },
        {
          title: '星陨播放器',
          des: '在星空中感受音乐的每一次律动，让歌词和流星与你同行',
          poster: poster1,
          url: mp4_1,
        },
        {
          title: 'AI 律动',
          des: 'AI 智能解析当前播放歌曲，随机生成沉浸式动态背景',
          poster: poster2,
          url: mp4_2,
        },
      ],
    }
  },
  watch: {
    activeIndex(index) {
      this.nextVideoPlay(index)
    },
  },
  mounted() {
    this.videoPlayByVisible()
    this.nextVideoPlay(this.activeIndex)
  },
  methods: {
    replayVideo,
    controlClick(index) {
      this.activeIndex = index
      setTimeout(() => {
        this.controlList.forEach((item, index) => {
          if (this.activeIndex === index) {
            this.$refs[`sliderVideo${index}`][0].play()
          } else {
            this.$refs[`sliderVideo${index}`][0].currentTime = 0
            this.$refs[`sliderVideo${index}`][0].pause()
          }
        })
      }, 100)
    },
    // 超出可视范围后暂停播放
    videoPlayByVisible() {
      this.$refs.video2 && videoPlayByVisibleArea(this.$refs.video2)
      this.controlList.forEach((_, index) => {
        const video = this.$refs[`sliderVideo${index}`][0]
        video && videoPlayByVisibleArea(video)
      })
    },
    // 播放完成后自动跳转到下一个视频
    nextVideoPlay(index) {
      // 清除所有 ended 事件监听器
      this.videoAbortController.abort()
      this.videoAbortController = new AbortController()
      const video = this.$refs[`sliderVideo${index}`][0]
      const nextVideoPlay = () => {
        this.activeIndex = (index + 1) % this.controlList.length
        this.controlClick(this.activeIndex)
        video.removeEventListener('ended', nextVideoPlay)
      }
      video.addEventListener('ended', nextVideoPlay, {
        signal: this.videoAbortController.signal,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.f-37 {
  width: 100%;
  position: sticky;
  z-index: 79;
  .alive_content {
    background: #ffffff;
    width: 100%;
    margin-bottom: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      margin: 50px 0;
      font-weight: 700;
      display: flex;
      // 设置背景
      background: radial-gradient(
        83.84% 58.59% at 49.68% 19.19%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      .title_bold {
        font-weight: 700;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .video_size {
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
          border-radius: 16px;
          object-fit: cover;
          object-position: center;
        }
      }

      .replay {
        margin-top: 20px;
        color: #3b82fc;
        position: relative;
        z-index: 1;
      }
      .des {
        position: relative;
        z-index: 0;
        display: flex;
        width: 100%;
        justify-content: flex-end;
        .des_text {
          position: absolute;
          width: 100%;
          top: 20px;
          text-align: center;
          color: black;
        }
      }
    }
  }
  .control_container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    .alive_control {
      border-radius: 100px;
      background-color: #f4f4f5;
      margin-bottom: 40px;
      padding: 6px;
      height: max-content;
      display: flex;
      width: max-content;
      gap: 10px;
      .control_item {
        cursor: pointer;
        font-size: 16px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        padding: 0 16px;
        height: 40px;
        color: #00000080;
      }
      .control_item_active {
        color: black;
        font-weight: 600;
        background-color: white;
      }
    }
  }
}
</style>
